import * as React from "react";
const SvgTotalUsers = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={31}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M20.849 3.93a4.905 4.905 0 0 1 4.908 4.908c0 2.65-2.104 4.81-4.726 4.908a1.6 1.6 0 0 0-.365 0m2.89 12.62c1.009-.21 1.962-.616 2.748-1.22 2.187-1.64 2.187-4.346 0-5.987-.771-.59-1.711-.982-2.707-1.206m-12.915-4.39a2.6 2.6 0 0 0-.463 0 6.2 6.2 0 0 1-5.988-6.212 6.22 6.22 0 0 1 6.227-6.226 6.23 6.23 0 0 1 6.226 6.226c-.014 3.366-2.665 6.1-6.002 6.213M3.67 18.739c-3.393 2.272-3.393 5.974 0 8.232 3.857 2.58 10.181 2.58 14.037 0 3.394-2.272 3.394-5.974 0-8.232-3.842-2.566-10.166-2.566-14.037 0"
    />
  </svg>
);
export default SvgTotalUsers;
